let exhibition_data = [
    {
        name: 'FILA U2K LOOK',
        content: '최근 힙한 Y2K 감성으로 LOOK을 표현한',
        content2: 'FILA의 신상 슈즈 인터런과 슬랜트샷을 만나보세요.',
        imgUrl: '/img/exhibition1.jpg'
    },
    {
        name: 'ONLINE EXCLUSIVE 23FW COLLECTION',
        content: '오직 온라인에서만 만나볼 수 있는 휠라의 23FW 온라인단독 컬렉션',
        imgUrl: '/img/exhibition2.jpg'
    },
    {
        name: 'ONLINE EXCLUSIVE 23FW COLLECTION',
        content: '1992년 처음 출시된 FILA HERITAGE TENNIS화 MATCH',
        imgUrl: '/img/exhibition3.jpg'
    },
    {
        name: 'FILA MELVIS PRO',
        content: '아웃도어 무드가 담긴 코트슈즈를 만나보세요.',
        imgUrl: '/img/exhibition4.jpg'
    },
    {
        name: 'FILA TENNIS HERITAGE',
        content: '23 FW COLLECTION',
        imgUrl: '/img/exhibition5.jpg'
    },
    {
        name: 'OAKMONT v3',
        content: 'OUTDOOR 무드의 OAKMONT TR의 새로운 스타일을 만나보세요.',
        imgUrl: '/img/exhibition6.jpg'
    }
]


export default exhibition_data;